// Where the buyer's email is stashed at sign-in. GET /auth/session returns the
// actorId but not the email, so as a frontend-only interim we remember the email
// the buyer typed on the sign-in screen (see LoginPage) and use it for the viewer
// watermark.
//
// FOLLOW-UP (small): once the session carries the buyer identity (an email/`me`
// field on the session response), source the watermark identity from that
// server-verified value instead of this typed-and-remembered one.
const BUYER_EMAIL_KEY = 'dataroom.buyerEmail';

/** Persist the email the buyer signed in with (best-available identity source). */
export function rememberBuyerEmail(email: string): void {
  try {
    sessionStorage.setItem(BUYER_EMAIL_KEY, email);
  } catch {
    // sessionStorage can be unavailable (private mode / disabled storage); the
    // watermark falls back to room context, so a failure here is non-fatal.
  }
}

/**
 * The best-available viewer identity for the watermark: the remembered buyer
 * email when we have it, otherwise the room context. Never throws.
 */
export function getViewerIdentity(): string {
  try {
    const email = sessionStorage.getItem(BUYER_EMAIL_KEY);
    if (email) return email;
  } catch {
    // ignore — fall through to room context
  }
  return 'this data room';
}
